module.exports = __webpack_public_path__ + "static/media/customer-type.a24960ee.svg";